import { Suspense, useEffect } from "react";
import { selectorTransversal, selectorTransversalNumerico } from "../../../../dtos/selector";
import { FiltroBusquedaSII } from "../models/filtroBusquedaSII";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { Grid2 } from "@mui/material";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { FilterList } from "@mui/icons-material";

interface IProps{
    onSubmit: (e: FiltroBusquedaSII) => void;
}

export const FormularioBusquedaSII = ({onSubmit} : IProps) => {

    const certificadosDisponibles : selectorTransversalNumerico[] = [
        {label: "Certificado 20", value: 20},
        {label: "Certificado 19", value: 19}
    ];

    const estadosDisponibles : selectorTransversal[] = [
        {label: "Generados", value: "S"},
        {label: "No generados", value: "N"}
    ];

    const anioMax = new Date().getFullYear();

    const schema = Yup.object<FiltroBusquedaSII>().shape({
        anio: Yup.number().required("Campo requerido").max(anioMax, "El año no puede superar el año actual"),
        numeroCertificado: Yup.number().required("Campo requerido"),
        nombre: Yup.string().optional(),
        rut: Yup.string().optional(),
        numeroOperacion: Yup.string().optional(),
        esGuardado: Yup.string().nullable().optional()
    });

    const {
        control,
        formState: { errors, isDirty },
        reset,
        watch,
        handleSubmit,
        setError,
        setValue
    } = useForm<FiltroBusquedaSII>({
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    useEffect(() => {
        setValue("anio", anioMax - 1)
        setValue("numeroCertificado", 20)
    }, [])

    return(
        <Suspense>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputNumber
                            name={"anio"}
                            control={control}
                            decimales={0}
                            label="Año"
                            error={errors.anio}
                            minValue={0}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputSelect
                            label="Tipo de certificado"
                            name={'numeroCertificado'}
                            control={control}
                            options={certificadosDisponibles}
                            error={errors.numeroCertificado}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputText
                            name={"nombre"}
                            control={control}
                            label="Nombre deudor"
                            error={errors.nombre}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputRut
                            name={"rut"}
                            control={control}
                            label="RUT deudor"
                            error={errors.rut}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputText
                            name={"numeroOperacion"}
                            control={control}
                            label="Número operación"
                            error={errors.numeroOperacion}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputSelect
                            label="Estado"
                            name={'esGuardado'}
                            control={control}
                            options={estadosDisponibles}
                            error={errors.esGuardado}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                        Filtrar
                    </MButton>
                </Grid2>
            </form>
        </Suspense>
    )
}